import { userCache } from '@/store/userInfo';

export const setActiveApiKey = (apiKey: string, appUuid?: string) => {
  userCache.activeApiKey = apiKey || '';
  userCache.activeApiKeyAppUuid = appUuid || userCache.currentAppUuid || '';
};

export const clearActiveApiKey = () => {
  userCache.activeApiKey = '';
  userCache.activeApiKeyAppUuid = '';
};
